import { render } from "./WaitTimes.vue?vue&type=template&id=603f35e0&scoped=true"
import script from "./WaitTimes.vue?vue&type=script&lang=js"
export * from "./WaitTimes.vue?vue&type=script&lang=js"

import "./WaitTimes.vue?vue&type=style&index=0&id=603f35e0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src396721354/src/serverlesspressoV3/frontends/vue-display-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603f35e0"]])

export default __exports__